import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import {
  Character,
  SpellLimitation,
  Spell,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";
import DandDAPI from "@dndUtilities/system_api";

import CharacterSpellBookSpellsOfLevel from "@dndComponents/character/inventory/book/CharacterSpellBookSpellsOfLevel";
import LoadingBox from "@components/input/LoadingBox";
import FilterBox from "@dndComponents/filtering/FilterBox";
import { SpellLevel } from "@dndModels/Types";

interface Props {
  character: Character;
  limit: SpellLimitation;
  onChange: () => void;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

/**
 * Making it so that Books can have data stored in them.
 * Book Types: Spell, Creature, Item, Other.
 * Spell Books work kind of like a collection of Scrolls, but can only be used for learning, not casting, but don't get used up in the process.
 * Creature Books and Item Books are just used to record and read info about them.
 * Other is the standard one, and it just has a place for the owner to record whatever they want.
 */
export default function CharacterViewSpellBookControls({
  character,
  limit,
  onChange,
}: Props) {
  const [spells, setSpells] = useState<Spell[]>([]);
  const [filtered, setFiltered] = useState<Spell[]>([]);
  // const [filter, setFilter] = useState<any>({ });
  const [levels, setLevels] = useState<SpellLevel[]>([]);

  // eslint-disable-next-line
  useEffect(() => {
    const load = () => {
      const new_spells = char_util.spellsThatFitLimit(character, limit).sort((a,b) => a.true_name.localeCompare(b.true_name));
      setSpells(new_spells);
      setFiltered(new_spells);
      setLevels((common_util.unique_array(new_spells.map(o => o.level))).sort());
    };

    load();
  }, []);

  const updateFilter = (changed: any) => {
    const the_filter = {...changed};
    let new_filtered = [...spells];
    if (the_filter.effect_type) {
      the_filter.effect_types = the_filter.effect_type;
      delete the_filter.effect_type;
    }
    if (the_filter.attack_type) {
      the_filter.attack_types = the_filter.attack_type;
      delete the_filter.attack_type;
    }
    if (the_filter.known !== undefined) {
      if (the_filter.known) {
        new_filtered = new_filtered.filter(o => character.spells.filter(o2 => o2.spell_id === o._id).length > 0);
      } else {
        new_filtered = new_filtered.filter(o => character.spells.filter(o2 => o2.spell_id === o._id).length === 0);
      }
      delete the_filter.known;
    }
    // console.log(changed);
    // console.log(the_filter);
    // setFilter(the_filter);
    new_filtered = api.filter("spell", new_filtered, the_filter) as Spell[];
    setFiltered(new_filtered);
  }

  return (
    <>
      <Grid
        size={{
          xs: 12
        }}>
        <FilterBox
          data_type="spell"
          flat
          dont_use_api
          all_objects={spells}
          character_options={character.character_options}
          extra_fields={["known"]}
          quick_fields={["school","spell_level","spell_list","known"]}
          the_filter={{ search_string: [""] }}
          onChange={updateFilter}
        />
      </Grid>
      { levels.map(level => {
        const spells_of_level = filtered.filter(o => o.level === level);
        if (spells_of_level.length > 0) {
          return (
            <CharacterSpellBookSpellsOfLevel key={level}
              character={character}
              level={level}
              spells_of_level={spells_of_level}
              onChange={onChange}
            />
          );
        }
        return null;
      })}
    </>
  );
}